<template lang="pug">
  .main
    top-bar
    v-container.grey.lighten-4.px-4(style="max-width: 500px;")
      h1.text-center.my-8.grey--text.text--darken-3 {{ $t('forgot_password') }}
      p.text-center {{ $t('forgot_password_desc') }}
      v-card(outlined).mt-4.pa-4
        v-card-text
          v-text-field(color="primary" v-model="email" type="email" label="Email address" outlined @keyup.enter="submit")
          v-btn.font-weight-bold(color="accent" x-large block depressed @click="submit" :loading="loading") {{ $t('submit') }}
</template>

<script>
  import TopBar from '@/components/TopBar'
  import { mapGetters } from 'vuex'

  export default {
    name: 'Forgot',
    components: { TopBar },
    props: ['signInEmail'],
    data: (vm) => ({
      loading: false,
      email: vm.signInEmail
    }),
    computed: {
      ...mapGetters({
        lang: 'language/getLanguage'
      }),
    },
    methods: {
      submit () {
        this.loading = true
        this.$axios.get(`/users/check_email/?email=${encodeURIComponent(this.email)}`)
          .then(resp => {
            if (resp.data.available) {
              alert(`${this.email} is not registered with Yezza`)
              this.loading = false
            } else {
              this.$axios.post('/users/send_verification_code/', { email: this.email, language: this.lang })
                .then(() => {
                  this.$router.push({ name: 'Verify', params: { email: this.email, pushTo: 'ResetPassword' }})
                })
                .catch(() => {
                })
                .finally(() => {
                  this.loading = false
                })
            }
          })
          .catch(() => {})
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>

<i18n>
{
  "en": {
    "forgot_password": "Forgot your password?",
    "forgot_password_desc": "Enter your email address to reset your password. You may need to check your spam folder or unblock no-reply@yezza.io."
  },
  "id": {
    "forgot_password": "Lupa kata sandi?",
    "forgot_password_desc": "Masukkan email untuk mengatur ulang kata sandi kamu. kamu mungkin perlu memeriksa folder spam atau membuka blokir no-reply@yezza.io."
  }
}
</i18n>
